import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconKanbanView: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="kanban-view, columns"><path d="M9.75 4.75H14.25V19.25H9.75V4.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M2.75 4.75H7.25V15.1071H2.75V4.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M16.75 4.75H21.25V13.0357H16.75V4.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconKanbanView;
